<template>
  <a-modal title="Turnos Extra / Reemplazos"
           :visible="visible"
           width="90%"
           @ok="close"
           @cancel="close"
           style="top: 20px;">
    <g-master name="exshiftMaster"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              @fieldsChange="masterFieldsChange"
              ref="exshiftMaster">

      <template slot="masterModal" slot-scope="{registro}">

        <g-dropdown endpoint="hierarchy_lookup"
                    label="Grupo"
                    :decorator="['id_h_att1', {rules: [{required: true, message: 'Valor requerido'}]}]"
                    :formItemConfig="fiOptions"
                    :params="master.request.grupoRequest"
                    :selectedObj.sync="grupoSeleccionado"
                    ref="exSGrupo"></g-dropdown>

        <g-dropdown endpoint="hierarchy_lookup"
                    label="Puesto"
                    :decorator="['id_h_att2', {rules: [{required: true, message: 'Valor requerido'}]}]"
                    :formItemConfig="fiOptions"
                    :params="puestoParams"
                    :selectedObj.sync="puestoSeleccionado"
                    ref="exSPuesto"></g-dropdown>

        <a-form-item label="Fecha" v-bind="fiOptions">
          <a-date-picker style="width: 100%"
                         v-decorator="['start_time', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
        </a-form-item>

        <g-dropdown endpoint="shifts_setup"
                    label="Turno"
                    :decorator="['id_shifts_setup', {rules: [{required: true, message: 'Valor requerido'}]}]"
                    :formItemConfig="fiOptions"
                    :params="master.request.turnoReques"></g-dropdown>

        <g-lookup label="Empleado"
                  :formItemConfig="fiOptions"
                  endpoint="empleados"
                  v-show="idGrupoPuestoSelected"
                  :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  :params="empParams"
                  ref="gestEmpDropDown">
        </g-lookup>

        <g-dropdown endpoint="hierarchy_lookup"
                    label="Tipo Turno"
                    :decorator="['id_h_shift_type', {rules: [{required: true, message: 'Valor requerido'}]}]"
                    :formItemConfig="fiOptions"
                    :params="master.request.tipoTurnoRequest"
                    :selectedObj.sync="tipoTurnoSeleccionado"></g-dropdown>

        <g-lookup label="Empleado Reemplaza"
                  :formItemConfig="fiOptions"
                  endpoint="empleados"
                  v-show="idEmpReemplazoRequired"
                  :decorator="['id_emp_replacement', { rules: [{ required: idEmpReemplazoRequired, message: 'Valor requerido' }] }]"
                  ref="gestEmpReplDropDown">
        </g-lookup>

        <a-form-item v-bind="fiOptions" label="Obervación">
          <a-textarea placeholder="Obervación" :rows="4" v-decorator="['work', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
        </a-form-item>

      </template>
    </g-master>
  </a-modal>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['visible', 'month'],
    data () {
      return {
        fiOptions: {
          'label-col': {span: 10},
          'wrapper-col': {span: 14},
          'has-feedback': true
        },
        master: {
          endpoint: 'overtime_replacement',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Grupo', dataIndex: 'desc_id_h_att_1', sorter: true},
              {title: 'Puesto', dataIndex: 'desc_id_h_att_2', sorter: true},
              {title: 'Fecha', dataIndex: 'start_time', sorter: true},
              {title: 'Turno', dataIndex: 'id_shifts_setup_name', sorter: true},
              {title: 'Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre', dataIndex: 'id_emp_name', sorter: true},
              {title: 'Empleado Reemplaza', dataIndex: 'id_emp_replacement', sorter: true},
              {title: 'Nombre', dataIndex: 'id_emp_replacement_name', sorter: true},
              {title: 'Observación', dataIndex: 'work', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_h_att1'},
            {name: 'id_h_att2'},
            {name: 'start_time', type: 'date'},
            {name: 'id_shifts_setup'},
            {name: 'id_emp'},
            {name: 'id_h_shift_type'},
            {name: 'id_emp_replacement'},
            {name: 'work'}
          ],
          request: {
            grupoRequest: {
              h_lookup_type: 'ID_H_ATT1'
            },
            turnoReques: {
              allow_edit: 1
            },
            tipoTurnoRequest: {
              h_lookup_type: 'TIPO_TURNO_ADICIONAL'
            }
          }
        },
        grupoSeleccionado: {},
        puestoSeleccionado: {},
        tipoTurnoSeleccionado: {}
      }
    },
    mounted () {},
    methods: {
      close () {
        this.$emit('ok')
      },
      masterFieldsChange (changedFields) {
        if (!JsUtils.isEmpty(changedFields.id_h_att1)) {
          if (JsUtils.isEmpty(changedFields.id_h_att1.value)) {
            this.grupoSeleccionado = {}
          } else {
            this.$refs.exSGrupo && this.$refs.exSGrupo.handleChange(changedFields.id_h_att1.value)
          }
        }

        if (!JsUtils.isEmpty(changedFields.id_h_att2)) {
          if (JsUtils.isEmpty(changedFields.id_h_att2.value)) {
            this.puestoSeleccionado = {}
          } else {
            this.$refs.exSPuesto && this.$refs.exSPuesto.handleChange(changedFields.id_h_att2.value)
          }
        }
      }
    },
    computed: {
      puestoParams () {
        return {
          // por solicitud de KR se cambia puesto_turno por id_h_att2 15/04/2020
          h_lookup_type: 'ID_H_ATT2',
          id_h_lookup_father: this.grupoSeleccionado.value ? this.grupoSeleccionado.value : -1
        }
      },
      idEmpReemplazoRequired () {
        return !JsUtils.isEmpty(this.tipoTurnoSeleccionado) && this.tipoTurnoSeleccionado.text === 'REEMPLAZO'
      },
      idGrupoPuestoSelected () {
        return !JsUtils.isEmpty(this.grupoSeleccionado) && !JsUtils.isEmpty(this.puestoSeleccionado)
      },
      empParams () {
        console.log('grupo', JsUtils.isEmpty(this.grupoSeleccionado))
        console.log('puesto', JsUtils.isEmpty(this.puestoSeleccionado))
        return {
          id_h_att1: JsUtils.isEmpty(this.grupoSeleccionado) ? '-1' : this.grupoSeleccionado.value,
          id_h_att2: JsUtils.isEmpty(this.puestoSeleccionado) ? '-1' : this.puestoSeleccionado.value
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ShiftsManagement/ExtraShiftModal.vue